import { render, staticRenderFns } from "./left_panel_reviews_summary.vue?vue&type=template&id=180a3671&scoped=true"
import script from "./left_panel_reviews_summary.vue?vue&type=script&lang=js"
export * from "./left_panel_reviews_summary.vue?vue&type=script&lang=js"
import style0 from "./left_panel_reviews_summary.vue?vue&type=style&index=0&id=180a3671&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180a3671",
  null
  
)

export default component.exports